/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollowLeague = {
    properties: {
        league: {
            type: 'LeagueListElement',
            isRequired: true,
        },
    },
} as const;
